import { type FC, useCallback } from "react";
import { Button } from "@vector-im/compound-web";
import { Config } from "../config/Config";

export const SSOButton: FC = () => {
  const homeserver = Config.defaultHomeserverUrl();
  const returnUrl = encodeURIComponent(window.location.origin);
  const ssoUrl = `${homeserver}/_matrix/client/v3/login/sso/redirect?redirectUrl=${returnUrl}`;

  const onClick = useCallback(() => {
    window.location.href = ssoUrl;
  }, [ssoUrl]);

  return (
    <Button
      onClick={onClick}
      kind="primary"
      style={{ width: "100%", maxWidth: "300px", margin: "16px auto 0", backgroundColor: "#ffffff", color: "#000000" }}
    >
      Continue with SSO
    </Button>
  );
};
